import { apiClient } from "./client";
import type { NotificationKind } from "./notifications";

export type PreferenceRow = {
  kind: NotificationKind;
  inapp_enabled: boolean;
  email_enabled: boolean;
  is_default: boolean;
};

export type PreferencesPayload = {
  items: PreferenceRow[];
};

export async function getNotificationPreferences(): Promise<PreferencesPayload> {
  const { data } = await apiClient.get<PreferencesPayload>(
    "/api/v1/me/notification-preferences",
  );
  return data;
}

export async function updateNotificationPreferences(
  items: Pick<PreferenceRow, "kind" | "inapp_enabled" | "email_enabled">[],
): Promise<PreferencesPayload> {
  const { data } = await apiClient.put<PreferencesPayload>(
    "/api/v1/me/notification-preferences",
    { items },
  );
  return data;
}

export type SnoozeState = {
  until: string | null;
  active: boolean;
};

export async function getNotificationSnooze(): Promise<SnoozeState> {
  const { data } = await apiClient.get<SnoozeState>(
    "/api/v1/me/notification-snooze",
  );
  return data;
}

export async function setNotificationSnooze(
  until: string | null,
): Promise<SnoozeState> {
  const { data } = await apiClient.put<SnoozeState>(
    "/api/v1/me/notification-snooze",
    { until },
  );
  return data;
}

export type QuietHoursState = {
  start: string | null;
  end: string | null;
  enabled: boolean;
};

export async function getQuietHours(): Promise<QuietHoursState> {
  const { data } = await apiClient.get<QuietHoursState>(
    "/api/v1/me/notification-quiet-hours",
  );
  return data;
}

export async function setQuietHours(
  start: string | null,
  end: string | null,
): Promise<QuietHoursState> {
  const { data } = await apiClient.put<QuietHoursState>(
    "/api/v1/me/notification-quiet-hours",
    { start, end },
  );
  return data;
}
